import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { transformTagNames } from '../../../global/transform-tag-name';
import { DEFAULT_CONTROLS } from '../../video/video.constants';
import { Ratio } from '../../aspect-ratio/ratio';

/** @slot - content placed below image  */
@Component({
  tag: 'wb-gallery-item',
  styleUrl: './gallery-item.scss',
  shadow: true,
})
export class GalleryItemComponent implements ComponentInterface {
  /** the image's src attribute (alternatively use `srcSet`) */
  @Prop()
  public src: string;

  /** the video's src attribute */
  @Prop()
  public videoSrc: string;

  /** the video's thumbnail attribute */
  @Prop()
  public videoThumb: string;

  /** the video's play aria label */
  @Prop()
  public videoPlayAriaLabel: string;

  /** the video's pause aria label */
  @Prop()
  public videoPauseAriaLabel: string;

  /** the image's srcSet attribute (alternatively use `src`) */
  @Prop()
  public srcSet: string;

  /** the image's alt attribute */
  @Prop()
  public alt?: string;

  /** Controls and the order in which they are displayed in the player */
  @Prop()
  public controls: string = DEFAULT_CONTROLS;

  /** Defines the starting volume of the video */
  @Prop({ mutable: true })
  public volume: number = 1;

  /** Time (in seconds) of the video. Can be used initially or during component runtime */
  @Prop({ reflect: true })
  public time: number = 0;

  /** @internal aspect ratio */
  @Prop({ reflect: true })
  public ratio: Ratio = '16x9';

  private TagNames = transformTagNames(this, 'wb-gallery-item', ['wb-aspect-ratio', 'wb-video']);

  public render(): JSX.Element {
    const { WbAspectRatio } = this.TagNames;
    const { WbVideo } = this.TagNames;

    return (
      <Host class="wb-gallery-item">
        {!this.videoSrc && (
          <WbAspectRatio ratio={this.ratio}>
            <img src={this.src} srcset={this.srcSet} alt={this.alt} />
          </WbAspectRatio>
        )}
        {this.videoSrc && <WbVideo src={this.videoSrc} controls={this.controls} time={this.time} volume={this.volume} play-aria-label={this.videoPlayAriaLabel} pause-aria-label={this.videoPauseAriaLabel}></WbVideo>}
        <slot />
      </Host>
    );
  }
}
